import { render, staticRenderFns } from "./baseInfoTabs.vue?vue&type=template&id=4649df4a&scoped=true"
import script from "./baseInfoTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./baseInfoTabs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./baseInfoTabs.vue?vue&type=style&index=0&id=4649df4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4649df4a",
  null
  
)

export default component.exports